import { $ as $a1ea59d68270f0dd$export$f8168d8dd8fd66e6 } from "./useFocus-Dfx9Kx9M.js";
import { $ as $507fabe10e71c6fb$export$b9b3dfddab17db27, a as $507fabe10e71c6fb$export$ec71b4b83ac08ec3 } from "./useFocusVisible-BzJye3ka.js";
import { $ as $9ab94262bd0047c7$export$420e68273165f4ec } from "./useFocusWithin-BmXs9szg.js";
import { useRef, useState, useCallback } from "react";
function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
  let { autoFocus = false, isTextInput, within } = props;
  let state = useRef({
    isFocused: false,
    isFocusVisible: autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  });
  let [isFocused, setFocused] = useState(false);
  let [isFocusVisibleState, setFocusVisible] = useState(() => state.current.isFocused && state.current.isFocusVisible);
  let updateState = useCallback(() => setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
  let onFocusChange = useCallback((isFocused2) => {
    state.current.isFocused = isFocused2;
    setFocused(isFocused2);
    updateState();
  }, [
    updateState
  ]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3((isFocusVisible) => {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput
  });
  let { focusProps } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: within,
    onFocusChange
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !within,
    onFocusWithinChange: onFocusChange
  });
  return {
    isFocused,
    isFocusVisible: isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
const focusRing = "_focusRing_giofa_3";
const focus = {
  focusRing
};
export {
  $f7dceffc5ad7768b$export$4e328f61c538687f as $,
  focus as f
};
